




















import Vue from 'vue';
import HAvatar from '@/ui/components/base/HAvatar.vue';

export default Vue.extend({
  name: 'HProfileCard',
  components: {
    HAvatar,
  },
  props: {
    profile: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onGamertagClick() {
      this.$emit('gamertag-click');
    },
  },
});
